














































































































import Vue from "vue";
import loginService from "@/global/service/login";
import TheLayoutFooter from "@/components/TheLayoutFooter.vue";
import SidePart from "@/components/SidePart.vue";
import { CountDown } from "@/utils/countDown";
const countDown = new CountDown();
interface FormState {
  phoneInput: string;
  smsCodeInput: string;
  remember: boolean;
}
export default Vue.extend({
  components: { TheLayoutFooter, SidePart },
  data(): {
    showAccount: boolean;
    form: FormState;
    formRules: SquareConfig;
    accountList: SquareConfig[];
    buttonName: string;
    time: number;
    isDisabled: boolean;
    isActive: boolean;
    btnLoading: boolean;
    loginActive: boolean;
    loginType: number;
  } {
    return {
      showAccount: false,
      accountList: [],
      form: {
        phoneInput: "",
        smsCodeInput: "",
        remember: false,
      },
      formRules: {
        phoneInput: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: [],
          },
          {
            required: true,
            validator: this.checkPhone,
            trigger: ["blur"],
          },
        ],
        smsCodeInput: [
          {
            required: true,
            message: "请填写验证码",
            trigger: [],
          },
          {
            required: true,
            validator: this.checkCode,
            trigger: ["blur"],
          },
        ],
      },
      buttonName: "获取验证码",
      time: 60,
      isDisabled: false,
      btnLoading: false,
      isActive: false,
      loginActive: false,
      loginType: 1,
    };
  },
  watch: {
    $route(val) {
      this.loginType = val.path.includes("company") ? 1 : 2;
    },
  },
  created() {
    this.loginType = this.$route.path.includes("company") ? 1 : 2;
  },
  mounted() {},
  methods: {
    checkPhone(rule: any, value: string, cb: Function) {
      if (!value) {
        return;
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        cb("格式不正确");
      } else {
        cb();
      }
    },
    checkCode(rule: any, value: string, cb: Function) {
      if (!value) {
        return;
      } else if (value.trim().length !== 6) {
        cb("请输入六位验证码");
      } else {
        cb();
      }
    },
    getCode() {
      (this.$refs.formRef as any).validateField("phoneInput", (valid: any) => {
        if (!valid) {
          loginService.smsSend({ telephone: this.form.phoneInput });
          this.isActive = true;
          this.isDisabled = true;
          this.buttonName = this.time + "秒后重新发送";
          countDown.listen = ({ time = 0, status }: SquareConfig) => {
            if (status === "end") {
              this.buttonName = "获取验证码";
              this.time = 60;
              this.isActive = false;
              this.isDisabled = false;
              return;
            }
            this.time = time;
            const duration = Math.ceil(time / 1000) || 0;
            this.buttonName = duration + "秒后重新发送";
          };
          this.endTime = Date.now() + 1 * 60 * 1000;
          countDown.start(this.time * 1000, this.endTime);
          // let countdown = setInterval(() => {
          //   const nowTime = Date.now();
          //   this.time = (this.time * 1000 - interval) / 1000;
          //   const duration = Math.ceil((this.endTime - nowTime) / 1000);
          //   const time =
          //     duration <= Math.ceil(this.time)
          //       ? duration
          //       : Math.ceil(this.time);
          //   this.buttonName = time + "秒后重新发送";
          //   if (time <= 0) {
          //     this.buttonName = "获取验证码";
          //     this.time = 60;
          //     this.isActive = false;
          //     clearInterval(countdown);
          //   }
          // }, interval);
        }
      });
    },
    handleLogin() {
      (this.$refs.formRef as any).validate((valid: boolean) => {
        if (valid) {
          this.loginActive = true;
          let params = {
            telephone: this.form.phoneInput,
            code: this.form.smsCodeInput,
            remember: this.form.remember,
            type: this.loginType,
          };

          if (this.loginType == 1) {
            this.companyLogin(params);
          } else {
            this.schoolLogin(params);
          }
        }
      });
    },
    loginAccount(uuid: string) {
      let params = {
        telephone: this.form.phoneInput,
        code: this.form.smsCodeInput,
        remember: this.form.remember,
        uuid,
        type: this.loginType,
      };
      this.login(params);
    },
    login(params: SquareConfig) {
      this.loginActive = true;
      loginService
        .smsLogin(params, { withCredentials: true })
        .then(() => {
          let role = this.loginType;
          switch (role) {
            case 1:
              window.location.href = process.env.VUE_APP_HR_URL;
              break;
            case 2:
              window.location.href = process.env.VUE_APP_EDU_URL;
              break;
            default:
              window.location.href = process.env.VUE_APP_HR_URL;
          }
        })
        .finally(() => {
          this.loginActive = false;
        });
    },
    handleChange() {
      const name = this.loginType == 1 ? "schoolLogin" : "companyLogin";
      this.$router.push({ name: name });
    },
    companyLogin(params: SquareConfig) {
      loginService
        .getAccountList(params)
        .then((res: any) => {
          this.accountList = res;
          if (res.length === 0) {
            this.loginActive = false;
            this.$message.error("不存在该企业账户");
          } else if (res.length === 1) {
            this.login(params);
          } else if (res.length > 1) {
            this.showAccount = true;
            this.loginActive = false;
          }
        })
        .catch(() => {
          this.loginActive = false;
        });
    },
    schoolLogin(params: SquareConfig) {
      loginService
        .getAccountList(params)
        .then((res: any) => {
          this.accountList = res;
          if (res.length === 0) {
            this.loginActive = false;
            this.$message.error("不存在该学院账户");
          } else if (res.length === 1) {
            this.login(params);
          } else if (res.length > 1) {
            this.showAccount = true;
            this.loginActive = false;
          }
        })
        .catch(() => {
          this.loginActive = false;
        });
    },
  },
});
